export default __webpack_public_path__ + "static/media/peso.b3193527.svg";